module.exports = __webpack_public_path__ + "img/sign-in.ecc895a1.svg";